import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter, ModalProps } from '@slal/ui/modal';
import { Article, P } from '@slal/ui/typography';

export const FundChargesModal = ({ onClose, ...props }: ModalProps) => {
    return (
        <Modal onClose={onClose} title="Your total fund charge" {...props}>
            <ModalBody>
                <Article>
                    <P>
                        This is the total amount we charge each year for managing your funds and for the administration
                        of your plan. It's made up of the fund management charge (also sometimes known as the annual
                        management charge) plus any additional expenses, minus any scheme discounts that apply.
                    </P>
                </Article>
            </ModalBody>

            <ModalFooter>
                <Button variant="solid" color="secondary" onClick={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};
